export enum scopeType {
  RECRUITER_QUESTION = 'Recruiter Questions',
  CANDIDATE_SUMMARY = 'Candidate Summary',
}
export interface IPrompt {
  id?: number;
  promptTitle: string;
  prompt: string;
  active: boolean;
  default: boolean;
  jdCount: number;
  numberOfQuestion: number;
  workspaceId: string;
  scope: scopeType;
  numberOfWords: number;
}

export interface IcandidateSummary {
  resumeContent: string;
  jobDescription: string;
}
